import { space } from 'styled-system';
import styled from 'styled-components';
// helpers/constants
import * as G from '../../helpers';
//////////////////////////////////////////////////

export const Wrapper = styled.div`
  width: max-content;
  z-index: ${({ zi }) => zi || 20};
  max-height: ${({ maxHeight }) => maxHeight};
  overflow: ${({ overflow }) => overflow || 'auto'};
  min-width: ${({ minWidth }) => minWidth || '230px'};
  box-shadow: ${({ popperBoxShadow }) => popperBoxShadow};
  border-radius: ${({ popperBorderRadius }) => popperBorderRadius || '10px'};
  background-color: ${({ bgColor }) => bgColor || G.getTheme('colors.light.mainLight')};
  border: ${({ borderColor, borderWidth }) => `${
    borderWidth || '2px solid'} ${borderColor || 'rgba(53, 53, 53, 0.2)'}`};
`;

export const PopperComponentWrapper = styled.div`
  ${space}

  max-width: 100%;
  position: relative;
  width:  ${({ wrapperWidth }) => wrapperWidth || 'max-content'};
  pointer-events:  ${({ pointerEvents }) => pointerEvents || 'auto'};
  display: ${({ popperComponentWrapperDisplay }) => popperComponentWrapperDisplay};
`;
